import { gameState } from '../core/GameState.js';
import { ROW, TILE_X, FIELD_HALF_TILES } from '../core/Constants.js';

const X_LIMIT = FIELD_HALF_TILES * TILE_X;

export class DemoBot {
  constructor(player) {
    this.player = player;
    this.thinkTimer = 0;
  }

  update(dt) {
    const p = gameState.player;
    if (!p || p.dead || this.player.hop) return;

    this.thinkTimer -= dt;
    if (this.thinkTimer > 0) return;

    this.thinkTimer = 0.3 + Math.random() * 0.25;

    const nextRow = p.row + 1;
    const goalRow = gameState.level.goalRow || 10;

    if (nextRow > goalRow) {
      // Reached goal in demo mode, restart demo crossing from start bank
      p.row = 0;
      p.x = 0;
      this.player.spawn();
      return;
    }

    const laneObj = gameState.level.rows[nextRow];

    if (!laneObj || laneObj.type === ROW.GRASS) {
      // Safe to hop forward
      this.player.startHop(0, -1);
      return;
    }

    if (laneObj.type === ROW.RAIL) {
      // Check if train is approaching in target row
      const consist = laneObj.lane ? laneObj.lane.hits(p.x, 1.8) : null;
      if (!consist) {
        // Safe to hop forward!
        this.player.startHop(0, -1);
      } else {
        // Train in front! Side step or wait
        if (Math.random() < 0.6) {
          const dir = Math.random() < 0.5 ? 1 : -1;
          if (Math.abs(p.x + dir * TILE_X) <= X_LIMIT) {
            this.player.startHop(dir, 0);
          }
        }
      }
      return;
    }

    if (laneObj.type === ROW.FREIGHT) {
      // Check if flatcar is underfoot in next row
      const carrier = laneObj.lane ? laneObj.lane.carrierAt(p.x) : null;
      if (carrier) {
        // Flatcar is ready, hop forward!
        this.player.startHop(0, -1);
      } else {
        // Move towards center or wait for flatcar
        const dir = p.x > 0 ? -1 : 1;
        if (Math.abs(p.x + dir * TILE_X) <= X_LIMIT && Math.random() < 0.6) {
          this.player.startHop(dir, 0);
        }
      }
      return;
    }
  }
}
